import { render, staticRenderFns } from "./AttivitaTable.vue?vue&type=template&id=5ba73e0c&"
import script from "./AttivitaTable.vue?vue&type=script&lang=ts&"
export * from "./AttivitaTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports